import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import * as Actions from '../../store/actions';

import { ListItem, IconButton, Grid, Icon, TextField, Checkbox, Tooltip, Radio } from '@material-ui/core';

const styles = theme => ({
    container: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    textField: {
        marginLeft: theme.spacing.unit,
        marginRight: theme.spacing.unit,
        width: 200,
    },
    button: {
        margin: theme.spacing.unit,
    },
    expansion: {}
});

class ChoiceAnswer extends Component {

    handleChange = (field_name) => (event) => {
        const { answer, question, updateAnswer } = this.props;

        let value = event.target.value;
        if (event.target.type === 'checkbox' || event.target.type === 'radio') {
            value = event.target.checked ? 1 : 0;
        }

        const update_data = {
            [field_name]: value
        }

        updateAnswer(question.header.question_id, answer.header.answer_id, update_data);
    }

    render() {
        const { answer, question, classes, deleteAnswer, moveAnswer, view_type } = this.props;

        return (
            <ListItem key={answer.header.answer_id}>
                <Grid container>
                    <Grid item xs={1}>
                        <Grid container>
                            <Grid item xs={12}>
                                <IconButton
                                    variant="contained"
                                    onClick={() => moveAnswer(question.header.question_id, answer.header.answer_id, answer.header.DisplayOrder, 'UP')}
                                    disabled={view_type === 'detail'}
                                >
                                    <Icon style={{ fontSize: 15 }}>arrow_upward</Icon>
                                </IconButton>
                            </Grid>
                            <Grid item xs={12}>
                                <IconButton
                                    variant="contained"
                                    onClick={() => moveAnswer(question.header.question_id, answer.header.answer_id, answer.header.DisplayOrder, 'DOWN')}
                                    disabled={view_type === 'detail'}
                                >
                                    <Icon style={{ fontSize: 15 }}>arrow_downward</Icon>
                                </IconButton>
                            </Grid>
                        </Grid>
                    </Grid>
                
                    <Grid item xs={10}>
                        <TextField
                            label="Answer Text"
                            className={classes.textField}
                            value={answer.header.AnswerText}
                            onChange={this.handleChange('AnswerText')}
                            margin="normal"
                            style={{width: '95%'}}
                            disabled={view_type === 'detail'}
                            variant="outlined"
                            multiline
                            rowsMax="6"
                            autoFocus
                        />
                    </Grid>
                    <Grid item xs={1}>
                        <Tooltip title="Mark as correct">
                            {question.header.question_type_id === 1 ?
                                <Radio
                                    checked={(answer.header.Correct === 1 || answer.header.Correct === true)}
                                    onChange={this.handleChange('Correct')}
                                    value="Correct"
                                    name="correct_radio"
                                    disabled={view_type === 'detail'}
                                />
                                :
                                <Checkbox
                                    checked={(answer.header.Correct === 1 || answer.header.Correct === true)}
                                    onChange={this.handleChange('Correct')}
                                    value="Correct"
                                    disabled={view_type === 'detail'}
                                />
                            }
                        </Tooltip>
                        <Tooltip title="Delete Answer">
                            <IconButton
                                variant="contained"
                                onClick={() => deleteAnswer(question.header.question_id, answer.header.answer_id)}
                                disabled={view_type === 'detail'}
                            >
                                <Icon style={{ color: 'red' }}>close</Icon>
                            </IconButton>
                        </Tooltip>
                    </Grid>
                </Grid>
    
            </ListItem>
        );
    }
}


function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        updateAnswer: Actions.updateAnswer,
        deleteAnswer: Actions.deleteAnswer,
        moveAnswer:   Actions.moveAnswer,
    }, dispatch);
}

export default withStyles(styles, { withTheme: true })(withRouter(connect(null, mapDispatchToProps)(ChoiceAnswer)));


// WEBPACK FOOTER //
// src/main/content/quiz/quizBuilder/questionType/ChoiceAnswer.js